// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__B3ypR","title":"FrontImage_title__3XZas"};